var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.563,13.03v-3c0-.814-.659-1.474-1.472-1.474-.886,0-1.921,0-2.339,0-.031,1.006-.852,1.814-1.866,1.814s-1.835-.807-1.866-1.814h-2.341c-.814,0-1.474.66-1.474,1.474v3c-1.034,0-1.872.838-1.872,1.872s.838,1.872,1.872,1.872v3c0,.814.66,1.474,1.474,1.474h2.341c.031-1.006.852-1.814,1.866-1.814s1.834.807,1.866,1.814c.421,0,1.454,0,2.339,0,.814,0,1.473-.66,1.473-1.474v-3c1.034,0,1.872-.838,1.872-1.872s-.838-1.872-1.872-1.872Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.256,6.097c0-.814-.66-1.473-1.474-1.473h-3c0-1.034-.838-1.872-1.872-1.872s-1.872.838-1.872,1.872h-3c-.814,0-1.474.659-1.474,1.472,0,.886,0,1.921,0,2.339,1.006.031,1.814.852,1.814,1.866s-.807,1.835-1.814,1.866v2.341c0,.814.66,1.474,1.474,1.474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.e708967c72e37ad20236a62d0904530b.svg";
export { ForwardRef as ReactComponent };